export default "__VITE_ASSET__DiyuGQB$__"